<!--
  - SPDX-FileCopyrightText: 2018 Nextcloud GmbH and Nextcloud contributors
  - SPDX-License-Identifier: AGPL-3.0-or-later
-->

<template>
	<RouterView />
</template>

<script>
export default {
	name: 'ContactsRoot',
}
</script>
